import { notFoundHook } from 'src/router/hooks';
import { RouteLocationNormalized } from 'vue-router';

export default class RouteHooks {
  protected hookName = '';
  public constructor(
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
  ) {
    try {
      if (
        Object.keys(to).length == 0 ||
        !to.hasOwnProperty('meta') ||
        !to.meta.hasOwnProperty('hook') ||
        to.meta.hook == '' ||
        to.meta.hook !== 'notFoundHook'
      ) {
        return;
      }
      this.hookName = to.meta.hook as string;
      notFoundHook.execute(to, from);
    } catch (err) {
      logError(err);
    }
  }
}
